module.exports = __webpack_public_path__ + "img/332x454px.e6c80832.png";